export const actionTypes = {
    UPDATE_PURCHASED_LISTINGS: 'PURCHASES/UPDATE_PURCHASED_LISTINGS',
    UPDATE_PURCHASED_LISTINGS_ERROR: 'PURCHASES/UPDATE_PURCHASED_LISTINGS_ERROR',
    UPDATE_PURCHASED_LISTINGS_SUCCESS: 'PURCHASES/UPDATE_PURCHASED_LISTINGS_SUCCESS',
};
